import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import { OrderType } from "src/core/orders/api/orders.api";
import { OrderTypeText } from "src/core/orders/components/OrderTypeText";

/**
 * This function returns a reusable formated column definition for order type data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for order type data
 */
export const orderTypeColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor, column:
  Partial<Pick<DisplayColumnDef<TData>, "id" | "meta">>
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.id ? column.id : accessor,
    header: "Type",
    cell: info => <OrderTypeText type={info.cell.getValue() as OrderType} />,
    enableSorting: false,
    enableColumnFilter: true,
    enableResizing: true,
    minSize: 100,
    meta: {
      style: { align: "left" },
      filter: column.meta?.filter
    }
  } as DisplayColumnDef<TData>);
};
